import Vue from 'vue'
/**
 * Form Validation
 */
import { ValidationObserver, ValidationProvider, extend, configure, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'

const config = {
  mode: 'aggressive'
}

localize({
  en
})

// Sets the options.
configure(config)

// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

/* TODO: Fixed, not being called when {postcode:true} */
extend('postcode', {
  validate: value => {
    const regex = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/
    return regex.test(value)
  },
  message: 'This postcode in not valid'
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
